import { PessoaService } from '../../pessoa.service';
import { Responsavel } from './../responsavel';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-responsavel-detail',
  	templateUrl: './responsavelDetail.component.html',
  	styleUrls: ['./responsavelDetail.component.scss']
})

export class ResponsavelDetailComponent implements OnInit{
	
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	detailForm: FormGroup;
	responsavel: Responsavel;
	responsavel_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	dependentes:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(private pessoaService: PessoaService, private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder){
		this.detailForm = this.formBuilder.group({
			id: this.formBuilder.control(0),
			estrangeiro: this.formBuilder.control('N'),
			passaporte: this.formBuilder.control(''),
			passaporte_dt_validade: this.formBuilder.control(''),
			cpf: this.formBuilder.control(''),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			dt_nascimento: this.formBuilder.control(''),
			primeiro_nome: this.formBuilder.control(''),
			ultimo_nome: this.formBuilder.control(''),
			apelido: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			email: this.formBuilder.control(''),
			nacionalidade: this.formBuilder.control(''),
			naturalidade: this.formBuilder.control(''),
			status: this.formBuilder.control('A'),
			genero_id: this.formBuilder.control(''),
			genero: this.formBuilder.control(''),
			rg: this.formBuilder.control(''),
			rg_dt_emissao: this.formBuilder.control(''),
			rg_emissor: this.formBuilder.control(''),
			rg_uf: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			grau_parentesco: this.formBuilder.control(''),
			estado_civil: this.formBuilder.control(''),
			estado_civil_id: this.formBuilder.control(''),
			foto: this.formBuilder.control(''),
			pis: this.formBuilder.control(''),
			grau_instrucao_id: this.formBuilder.control(''),
			grau_instrucao: this.formBuilder.control(''),
		});	
		this.responsavel_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/responsavel',this.responsavel_id).subscribe(
		(responsavel) => {
			this.responsavel = responsavel.dados;
			this.pessoa_id = this.responsavel.pessoa_id;
			this.acesso = this.responsavel.acesso;
			if(this.responsavel.foto){
				this.thumb = this.responsavel.foto.thumb;
			}
			this.dependentes = this.responsavel.dependente;
			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})


				this.detailForm.patchValue({
					id: this.responsavel.id,
					estrangeiro: this.responsavel.estrangeiro,
					passaporte: this.responsavel.passaporte,
					passaporte_dt_validade: this.responsavel.passaporte_dt_validade_br,
					cpf: this.responsavel.cpf,
					dt_cadastro: this.responsavel.dt_cadastro_br,
					dt_atualizacao: this.responsavel.dt_atualizacao_br,
					genero_id: this.responsavel.genero_id,
					genero: this.responsavel.genero,
					primeiro_nome: this.responsavel.primeiro_nome,
					ultimo_nome: this.responsavel.ultimo_nome,
					nome_completo: this.responsavel.nome_completo,
					apelido: this.responsavel.apelido,
					email: this.responsavel.email,
					rg: this.responsavel.rg,
					rg_uf: this.responsavel.rg_uf,
					rg_dt_emissao: this.responsavel.rg_dt_emissao_br,
					rg_emissor: this.responsavel.rg_emissor,
					foto: this.thumb,
					observacao: this.responsavel.observacao,
					dt_nascimento: this.responsavel.dt_nascimento_br,
					status: this.responsavel.status,
					estado_civil: this.responsavel.estado_civil,
					estado_civil_id: this.responsavel.estado_civil_id,

					pis: this.responsavel.pis,
					grau_instrucao_id: this.responsavel.grau_instrucao_id,
					grau_instrucao: this.responsavel.grau_instrucao
				});
			})
		}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_responsavel.includes("CONSULTAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}